// Checkout.jsx (web)
import { AnimatePresence } from 'framer-motion'
import { useNavigate } from 'react-router-dom'

import { useApp } from '@/lib/hooks'

import { CheckoutBackground, CheckoutLogo, CheckoutWrapper } from './Checkout.styles'
import Cart from './components/Cart'
import Payment from './components/Payment'
import Summary from './components/Summary'
import Terminal from './components/Terminal'
import useCheckout from './hooks/useCheckout'

const Checkout = () => {
  const { currentStep, cart } = useCheckout()
  const { data: appSettings } = useApp()
  const { logo } = appSettings || {}
  const navigate = useNavigate()

  if (cart.length === 0 && navigate) {
    navigate('/menu')
  }

  return (
    <CheckoutWrapper>
      <CheckoutBackground />

      {logo && <CheckoutLogo src={logo.url} />}
      <AnimatePresence mode="wait">
        {currentStep === 'CART' && <Cart key="CART" />}
        {currentStep === 'PAYMENT' && <Payment key="PAYMENT" />}
        {currentStep === 'TERMINAL' && <Terminal key="TERMINAL" />}
        {currentStep === 'SUMMARY' && <Summary key="SUMMARY" />}
      </AnimatePresence>
    </CheckoutWrapper>
  )
}

export default Checkout
